import React,{useRef} from 'react';
import { Component } from 'react';
import ReactDOM from 'react-dom';

import Header from "../components/header";
import Float from "../components/float";
import Modals from "../components/modals";
import Footer from "../components/footer";

import List from "../components/shop/list";

export default class Shop extends Component {
    constructor(props){
        super(props)

        this.state = {
            name: 'Productos',
            text: [],
            brands_list: [],
            categories_list: [],
            years_list: [],
            vehicles_list: [],
            products:[],
            option:0,
            category_id:0,
            brand_id:0,
            year_id:0,
            vehicle_id:0,
            price_id:0,
            line_id: 0,
            brand_select: brand_select,
            category_select: category_select,
            brandsT: [],
            categoriesT: [],
            linesT: [],
            lines: [],
            error: null,
            brands:[],
            brands_2:[],
            categories:[],
            info:[],
            formRegister:{
                name:'',
                lastname:'',
                identy:'',
                mail:'',
                password:'',
                phone:'',
                address:'',
                town:'',
                token:'',
                country_id:'',
                state_id:'',
                city_id:'',
                description:''
            },
            countries:[],
            states:[],
            cities:[],
            formLogin:{
                user:'',
                password:'',
                token:'',
            },
        }

        this.formRegisterSubmit = this.formRegisterSubmit.bind(this)
        this.handleChangeFormRegister = this.handleChangeFormRegister.bind(this)
        this._recaptchaRefRegister = React.createRef();
        this.onChangeCountry = this.onChangeCountry.bind(this)
        this.onChangeState = this.onChangeState.bind(this)
        this.onChangeCity = this.onChangeCity.bind(this)

        this.forget = this.forget.bind(this);
        this.formLoginSubmit = this.formLoginSubmit.bind(this)
        this.handleChangeFormLogin = this.handleChangeFormLogin.bind(this)
        this._recaptchaRefLogin = React.createRef();

        this.changeBrand = this.changeBrand.bind(this)
        this.changeCategory = this.changeCategory.bind(this)
        this.onChangeOption = this.onChangeOption.bind(this)
        this.pagePrev = this.pagePrev.bind(this)
        this.pageNext = this.pageNext.bind(this)
        this.changeYear = this.changeYear.bind(this)
        this.changeVehicle = this.changeVehicle.bind(this)
        this.changePrice = this.changePrice.bind(this)

        this.brandOpen = this.brandOpen.bind(this)
        this.categoriesOpen = this.categoriesOpen.bind(this)
        this.yearsOpen = this.yearsOpen.bind(this)
        this.vehiclesOpen = this.vehiclesOpen.bind(this)
        this.priceOpen = this.priceOpen.bind(this)

        this.lineOpen = this.lineOpen.bind(this)
        this.changeLine = this.changeLine.bind(this)

        this.clearFilter = this.clearFilter.bind(this)
        this.clearMobile = this.clearMobile.bind(this)
    }

    //register_form started
    handleChangeFormRegister(e){
        this.setState({
            formRegister:{
                ...this.state.formRegister,
                [e.target.name]:e.target.value
            }
        })
    }
    
    onChangeCountry(e){
        this.setState({city: e.target.value});
        this.setState({
            formRegister:{
                ...this.state.formRegister,
                country_id:e.target.value,
            }
        });
        /*
        try{
            let config = {
                method: 'POST',
                headers:{
                    'Accept':'application/json',
                    'Content-Type':'application/json'
                },
                body: JSON.stringify(this.state.formRegister)
            }
            let res = await fetch(`${https}api/statesGet`,config)
            let data = await res.json();
            this.setState({
                states:data
            });
            fetch(`${https}api/statesGet`)
                .then(res => res.json())
                .then(res => {
                    this.setState({
                        states: res,
                    });
                });
        }catch (error) {
            this.setState({
                error
            })
        }
        */
    }

    onChangeState(e){
        this.setState({city: e.target.value});
        this.setState({
            formRegister:{
                ...this.state.formRegister,
                state_id:e.target.value,
            }
        });
    }

    onChangeCity(e){
        this.setState({city: e.target.value});
        this.setState({
            formRegister:{
                ...this.state.formRegister,
                city_id:e.target.value,
            }
        });
    }

    formRegisterSubmit = async (e) => {
        e.preventDefault()
        if(
            this.state.formRegister.name == '' ||
            this.state.formRegister.lastname == '' ||
            //this.state.formRegister.identy == '' ||
            this.state.formRegister.mail == '' ||
            this.state.formRegister.password == '' ||
            this.state.formRegister.phone == '' ||
            this.state.formRegister.address == ''||
            this.state.formRegister.town == '' ||
            this.state.formRegister.city_id == '' ||
            this.state.formRegister.description == ''
        ){
            swal({
                text: "Debes digitar todos los datos",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }

        swal({
            text: "Espere un momento",
            icon: imageURL,
            button: false,
            closeOnClickOutside: false,
        });

        const tokenRegister = await this._recaptchaRefRegister.current.executeAsync();
        this.setState({
            formRegister:{
                ...this.state.formRegister,
                token: tokenRegister
            }
        });

        if(!tokenRegister){
            swal({
                text: "Error, eres un robot",
                icon: "warning",
                button: "OK!",
                closeOnClickOutside: false,
            });
            return false;
        }
        try{
            let configRegister = {
                method: 'POST',
                headers:{
                    'Accept':'application/json',
                    'Content-Type':'application/json'
                },
                body: JSON.stringify(this.state.formRegister)
            }
            let resRegister = await fetch(`${https}api/register`,configRegister)
            let dataRegister = await resRegister.json()
            if(dataRegister == 1){
                this.setState({
                    formRegister:{
                        name:'',
                        lastname:'',
                        identy:'',
                        mail:'',
                        password:'',
                        phone:'',
                        address:'',
                        town:'',
                        token:'',
                        country_id:'',
                        state_id:'',
                        city_id:'',
                        description:''
                    },
                })
                swal.close();
                document.getElementById("formRegister").reset();
                $("#formRegister")[0].reset();
                swal({
                    text: "Gracias por registrarse, pronto nos contactaremos con usted",
                    icon: imageURL,
                    button: "OK!",
                    dangerMode: false,
                    closeOnClickOutside: false,
                })
                    .then((willDelete) => {
                        if (willDelete) {
                            location.reload();
                        } else {

                        }
                    });
            }else if(dataRegister == 2) {
                swal({
                    text: "Este usuario ya se encuentra registrado",
                    icon: "warning",
                    button: "OK!",
                });
            }else{
                alert('ocurrio un error');
                setTimeout(function (){
                    location.reload();
                },1000)
            }
        }catch (error) {
            this.setState({
                error
            })
        }
    }
    //register_form finished

    forget = async (e) =>{
        e.preventDefault()
        if(
            this.state.formLogin.user == ''
        ){
            swal({
                text: "Debes digitar el correo electronico",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }

        swal({
            text: "Espere un momento",
            icon: imageURL,
            button: false,
            closeOnClickOutside: false,
        });

        try{
            let configForget = {
                method: 'POST',
                headers:{
                    'Accept':'application/json',
                    'Content-Type':'application/json'
                },
                body: JSON.stringify(this.state.formLogin)
            }
            let resForget = await fetch(`${https}api/forget`,configForget)
            let dataForget = await resForget.json()
            if(dataForget == 1){
                swal({
                    text: "Se ha enviado un correo a "+this.state.formLogin.user,
                    icon: "warning",
                    button: "OK!",
                });
            }else if(dataForget == 2) {
                swal({
                    text: "Error de recaptcha",
                    icon: "warning",
                    button: "OK!",
                });
            }else if(dataForget == 3) {
                swal({
                    text: "Usuario no registrado",
                    icon: "warning",
                    button: "OK!",
                });
            }else if(dataForget == 4){
                swal({
                    text: "Su usuario no tiene los permisos necesarios para acceder",
                    icon: "warning",
                    button: "OK!",
                });
            }else{
                //console.log(dataForget);
                alert('ocurrio un error');
                setTimeout(function (){
                    location.reload();
                },1000)
            }
        }catch (error) {
            this.setState({
                error
            })
        }
    }

    handleChangeFormLogin(e){
        this.setState({
            formLogin:{
                ...this.state.formLogin,
                [e.target.name]:e.target.value
            }
        })
    }
    
    formLoginSubmit = async (e) => {
        e.preventDefault()
        if(
            this.state.formLogin.user == '' ||
            this.state.formLogin.password == ''
        ){
            swal({
                text: "Debes digitar todos los datos",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }

        swal({
            text: "Espere un momento",
            icon: imageURL,
            button: false,
            closeOnClickOutside: false,
        });

        const token = await this._recaptchaRefLogin.current.executeAsync();
        this.setState({
            formLogin:{
                ...this.state.formLogin,
                token: token
            }
        });
        if(!token){
            swal({
                text: "Error, eres un robot",
                icon: "warning",
                button: "OK!",
                closeOnClickOutside: false,
            });
            return false;
        }
        try{
            let configLogin = {
                method: 'POST',
                headers:{
                    'Accept':'application/json',
                    'Content-Type':'application/json'
                },
                body: JSON.stringify(this.state.formLogin)
            }
            let resLogin = await fetch(`${https}api/login`,configLogin)
            let dataLogin = await resLogin.json()
            if(dataLogin == 1){
                this.setState({
                    formLogin:{
                        user:'',
                        password:'',
                        token:'',
                    }
                })
                //document.getElementById("formLogin").reset();
                location.reload();
            }else if(dataLogin == 2) {
                swal({
                    text: "Error de recaptcha",
                    icon: "warning",
                    button: "OK!",
                });
            }else if(dataLogin == 3) {
                swal({
                    text: "Usuario o contraseña incorrecta",
                    icon: "warning",
                    button: "OK!",
                });
            }else if(dataLogin == 4){
                swal({
                    text: "Su usuario no tiene los permisos necesarios para acceder",
                    icon: "warning",
                    button: "OK!",
                });
            }else{
                alert('ocurrio un error');
                setTimeout(function (){
                    location.reload();
                },1000)
            }
        }catch (error) {
            this.setState({
                error
            })
        }
    }

    //filters shop
    changeBrand(id){
        this.setState({
            products:[],
        })
        //console.log('changeBrand');
        //console.log(id);
        if($(document).width() < 600 ){
            if($('#brand_mobile_'+id).is('.dnone')){
                this.setState({
                    brand_id:id,
                })
                $(".brand_list_mobile").addClass('dnone');
                $("#brand_mobile_"+id).removeClass('dnone');

                $('#results .brands p .name').html(
                    $('#brand_mobile_'+id).attr('name')
                );
                $('#results .brands').css('display','block');

            }else{
                this.setState({
                    brand_id:0,
                })
                id = 0;
                $(".brand_list_mobile").addClass('dnone');

                $('#results .brands').css('display','none');

            }
            document.getElementById('allCategories').classList.remove('show');
            document.getElementById('subMarca').classList.remove('show');document.body.classList.remove('lock-screen');
        }else{
            if( !$("#brand_"+id).is(':checked') ){
                this.setState({
                    brand_id:0,
                })
                id = 0;
                $("#brand_"+id).prop('checked', false);
                $(".brand_list").prop('checked', false);

                $('#p_results .brands').css('display','none');
            }else{
                this.setState({
                    brand_id:id,
                })
                $(".brand_list").prop('checked', false);
                $("#brand_"+id).prop('checked', true);

                $('#p_results .brands').html(
                    '&nbsp;> '+$('#brand_'+id).attr('name_go')
                );
                $('#p_results .brands').css('display','block');
            }
            //$('.list_check').css('display','none');
        }

        var option = this.state.option;
        if(option == ''){
            option = 1
        }
        var category_id = this.state.category_id;
        if(category_id == ''){
            category_id = 0
        }
        var year_id = this.state.year_id;
        if(year_id == ''){
            year_id = 0
        }
        var vehicle_id = this.state.vehicle_id;
        if(vehicle_id == ''){
            vehicle_id = 0
        }
        var price_id = this.state.price_id;
        if(price_id == ''){
            price_id = 0
        }
        var line_id = this.state.line_id;
        if(line_id == ''){
            line_id = 0
        }

        try{
            fetch(https+'api/filter/'+id+'/'+category_id+'/'+option+'/'+year_id+'/'+vehicle_id+'/'+price_id+'/'+line_id)
                .then(response => response.json())
                .then(data =>{
                    this.setState({
                        products:data[0],
                        brands_list:data[1],
                        categories_list:data[2],
                        lines:data[3],
                        years_list:data[4],
                        vehicles_list:data[5]
                    })
                    $('.pages').hide();
                    $('.page_1').show();
                    
                    $('.not_products').css('display','block');
                    $('.loading').css('display','none');
                    $('html, body').animate({
                        scrollTop: $('.listProducts').offset().top - 100
                    }, 100);
                })
        }catch (error) {
            this.setState({
                error
            })
        }
    }
    changeCategory(id){
        this.setState({
            products:[],
        })
        if($(document).width() < 600 ){
            if($('#category_mobile_'+id).is('.dnone')){
                this.setState({
                    category_id:id,
                })
                $(".category_list_mobile").addClass('dnone');
                $("#category_mobile_"+id).removeClass('dnone');
                
                $('#results .categories p .name').html(
                    $('#category_mobile_'+id).attr('name')
                );
                $('#results .categories').css('display','block');

            }else{
                this.setState({
                    category_id:0,
                })
                id = 0;
                $(".category_list_mobile").addClass('dnone');
                $('#results .categories').css('display','none');
            }
            document.getElementById('allCategories').classList.remove('show');
            document.getElementById('subProduct').classList.remove('show');
            document.body.classList.remove('lock-screen');
        }else{
            if( !$("#category_"+id).is(':checked') ){
                id = 0;
                this.setState({
                    category_id:0,
                })
                $("#category_"+id).prop('checked', false);
                $(".category_list").prop('checked', false);

                $('#p_results .categories').css('display','none');
            }else{
                this.setState({
                    category_id:id,
                })
                $(".category_list").prop('checked', false);
                $("#category_"+id).prop('checked', true);

                $('#p_results .categories').html(
                    '&nbsp;> '+$('#category_mobile_'+id).attr('name')
                );
                $('#p_results .categories').css('display','block');
            }
            //$('.list_check').css('display','none');
        }
        var option = this.state.option;
        if(option == ''){
            option = 1
        }
        var brand_id = this.state.brand_id;
        if(brand_id == ''){
            brand_id = 0
        }
        var year_id = this.state.year_id;
        if(year_id == ''){
            year_id = 0
        }
        var vehicle_id = this.state.vehicle_id;
        if(vehicle_id == ''){
            vehicle_id = 0
        }
        var price_id = this.state.price_id;
        if(price_id == ''){
            price_id = 0
        }
        var line_id = this.state.line_id;
        if(line_id == ''){
            line_id = 0
        }
        try{
            fetch(https+'api/filter/'+brand_id+'/'+id+'/'+option+'/'+year_id+'/'+vehicle_id+'/'+price_id+'/'+line_id)
                .then(response => response.json())
                .then(data =>{
                    this.setState({
                        products:data[0],
                        brands_list:data[1],
                        categories_list:data[2],
                        lines:data[3],
                        years_list:data[4],
                        vehicles_list:data[5]
                    })
                    $('.pages').hide();
                    $('.page_1').show();

                    $('.not_products').css('display','block');
                    $('.loading').css('display','none');
                    $('html, body').animate({
                        scrollTop: $('.listProducts').offset().top - 100
                    }, 100);
                })
        }catch (error) {
            this.setState({
                error
            })
        }
    }
    onChangeOption(e){
        this.setState({
            products:[],
        })

        this.setState({
            option: e.target.value
        });
        var brand_id = this.state.brand_id;
        if(brand_id == ''){
            brand_id = 0
        }
        var category_id = this.state.category_id;
        if(category_id == ''){
            category_id = 0
        }
        var year_id = this.state.year_id;
        if(year_id == ''){
            year_id = 0
        }
        var vehicle_id = this.state.vehicle_id;
        if(vehicle_id == ''){
            vehicle_id = 0
        }
        var price_id = this.state.price_id;
        if(price_id == ''){
            price_id = 0
        }
        var line_id = this.state.line_id;
        if(line_id == ''){
            line_id = 0
        }
        try{
            fetch(https+'api/filter/'+brand_id+'/'+category_id+'/'+e.target.value+'/'+year_id+'/'+vehicle_id+'/'+price_id+'/'+line_id)
                .then(response => response.json())
                .then(data =>{
                    this.setState({
                        products:data[0],
                        brands_list:data[1],
                        categories_list:data[2],
                        lines:data[3],
                        years_list:data[4],
                        vehicles_list:data[5]
                    })
                    $('.pages').hide();
                    $('.page_1').show();
                })
        }catch (error) {
            this.setState({
                error
            })
        }
    }
    pagePrev(id){
        id = $('.pagePrev').attr('id')
        if(id > 0){
            $('.pages').hide();
            $('.page_'+id).show();
            $('.pagePrev').attr('id',parseInt(id)-1)
            $('.pageNext').attr('id',parseInt(id)+1)
            $('html, body').animate({
                scrollTop: $('.listProducts').offset().top - 100
            }, 100);
        }else{
            swal({
                text: "No hay pagina anterior para mostrar",
                icon: imageURL,
                button: "OK!",
            });
        }
    }

    pageNext(id){
        id = $('.pageNext').attr('id')
        if( id > 1 ){
            if( $(".page_"+id).length == 0 ){
                swal({
                    text: "No hay pagina siguiente para mostrar",
                    icon: imageURL,
                    button: "OK!",
                });
                return false;
            }
            var id_next = parseInt(id) + 1;
            $('.pages').hide();
            $('.page_'+id).show();
            $('.pagePrev').attr('id',parseInt(id)-1)
            if($(".page_"+id_next).length >= 0){
                $('.pageNext').attr('id',id_next)
            }
            $('html, body').animate({
                scrollTop: $('.listProducts').offset().top - 100
            }, 100);
        }else{
            swal({
                text: "No hay pagina siguiente para mostrar",
                icon: imageURL,
                button: "OK!",
            });
        }
    }

    changeYear(id){
        this.setState({
            products:[],
        })
        if($(document).width() < 600 ){
            if($('#year_mobile_'+id).is('.dnone')){
                this.setState({
                    year_id:id,
                })
                $(".year_list_mobile").addClass('dnone');
                $("#year_mobile_"+id).removeClass('dnone');
                $('#results .years p .name').html(
                    $('#year_mobile_'+id).attr('name')
                );
                $('#results .years').css('display','block');
            }else{
                this.setState({
                    year_id:0,
                })
                id = 0;
                $(".year_list_mobile").addClass('dnone');
                $('#results .years').css('display','none');
            }
            document.getElementById('allCategories').classList.remove('show');
            document.getElementById('subYear').classList.remove('show');
            document.body.classList.remove('lock-screen');
        }else{
            if( !$("#year_"+id).is(':checked') ){
                id = 0;
                this.setState({
                    year_id:0,
                })
                $("#year_"+id).prop('checked', false);
                $(".year_list").prop('checked', false);

                $('#p_results .years').css('display','none');
            }else{
                this.setState({
                    year_id:id,
                })
                $(".year_list").prop('checked', false);
                $("#year_"+id).prop('checked', true);

                $('#p_results .years').html(
                    '&nbsp;> '+$('#year_mobile_'+id).attr('name')
                );
                $('#p_results .years').css('display','block');
            }
            //$('.list_check').css('display','none');
        }
        var option = this.state.option;
        if(option == ''){
            option = 1
        }
        var brand_id = this.state.brand_id;
        if(brand_id == ''){
            brand_id = 0
        }
        var category_id = this.state.category_id;
        if(category_id == ''){
            category_id = 0
        }
        var vehicle_id = this.state.vehicle_id;
        if(vehicle_id == ''){
            vehicle_id = 0
        }
        var price_id = this.state.price_id;
        if(price_id == ''){
            price_id = 0
        }
        var line_id = this.state.line_id;
        if(line_id == ''){
            line_id = 0
        }
        try{
            fetch(https+'api/filter/'+brand_id+'/'+category_id+'/'+option+'/'+id+'/'+vehicle_id+'/'+price_id+'/'+line_id)
                .then(response => response.json())
                .then(data =>{
                    this.setState({
                        products:data[0],
                        brands_list:data[1],
                        categories_list:data[2],
                        lines:data[3],
                        years_list:data[4],
                        vehicles_list:data[5]
                    })
                    $('.pages').hide();
                    $('.page_1').show();

                    $('.not_products').css('display','block');
                    $('.loading').css('display','none');
                    $('html, body').animate({
                        scrollTop: $('.listProducts').offset().top - 100
                    }, 100);
                })
        }catch (error) {
            this.setState({
                error
            })
        }
    }
    changeVehicle(id){
        this.setState({
            products:[],
        })
        if($(document).width() < 600 ){
            if($('#vehicle_mobile_'+id).is('.dnone')){
                this.setState({
                    vehicle_id:id,
                })
                $(".vehicle_list_mobile").addClass('dnone');
                $("#vehicle_mobile_"+id).removeClass('dnone');
                $('#results .vehicles p .name').html(
                    $('#vehicle_mobile_'+id).attr('name')
                );
                $('#results .vehicles').css('display','block');
            }else{
                this.setState({
                    vehicle_id:0,
                })
                id = 0;
                $(".vehicle_list_mobile").addClass('dnone');
                $('#results .vehicles').css('display','none');
            }
            document.getElementById('allCategories').classList.remove('show');
            document.getElementById('subVehicle').classList.remove('show');
            document.body.classList.remove('lock-screen');
        }else{
            if( !$("#vehicle_"+id).is(':checked') ){
                id = 0;
                this.setState({
                    vehicle_id:0,
                })
                $("#vehicle__"+id).prop('checked', false);
                $(".vehicle__list").prop('checked', false);

                $('#p_results .vehicles').css('display','none');
            }else{
                this.setState({
                    vehicle_id:id,
                })
                $(".vehicle__list").prop('checked', false);
                $("#vehicle__"+id).prop('checked', true);

                $('#p_results .vehicles').html(
                    '&nbsp;> '+$('#vehicle_mobile_'+id).attr('name')
                );
                $('#p_results .vehicles').css('display','block');
            }
            //$('.list_check').css('display','none');
        }
        var option = this.state.option;
        if(option == ''){
            option = 1
        }
        var brand_id = this.state.brand_id;
        if(brand_id == ''){
            brand_id = 0
        }
        var category_id = this.state.category_id;
        if(category_id == ''){
            category_id = 0
        }
        var year_id = this.state.year_id;
        if(year_id == ''){
            year_id = 0
        }
        var price_id = this.state.price_id;
        if(price_id == ''){
            price_id = 0
        }
        var line_id = this.state.line_id;
        if(line_id == ''){
            line_id = 0
        }
        try{
            fetch(https+'api/filter/'+brand_id+'/'+category_id+'/'+option+'/'+year_id+'/'+id+'/'+price_id+'/'+line_id)
                .then(response => response.json())
                .then(data =>{
                    this.setState({
                        products:data[0],
                        brands_list:data[1],
                        categories_list:data[2],
                        lines:data[3],
                        years_list:data[4],
                        vehicles_list:data[5]
                    })
                    $('.pages').hide();
                    $('.page_1').show();

                    $('.not_products').css('display','block');
                    $('.loading').css('display','none');
                    $('html, body').animate({
                        scrollTop: $('.listProducts').offset().top - 100
                    }, 100);
                })
        }catch (error) {
            this.setState({
                error
            })
        }
    }
    changePrice(id){
        this.setState({
            products:[],
        })
        if($(document).width() < 600 ){
            if($('#price_mobile_'+id).is('.dnone')){
                this.setState({
                    price_id:id,
                })
                $(".price_list_mobile").addClass('dnone');
                $("#price_mobile_"+id).removeClass('dnone');
                $('#results .prices p .name').html(
                    $('#price_mobile_'+id).attr('name')
                );
                $('#results .prices').css('display','block');
            }else{
                this.setState({
                    price_id:0,
                })
                id = 0;
                $(".price_list_mobile").addClass('dnone');
                $('#results .prices').css('display','none');
            }
            document.getElementById('allCategories').classList.remove('show');
            document.getElementById('subPrice').classList.remove('show');
            document.body.classList.remove('lock-screen');
        }else{
            if( !$("#price_"+id).is(':checked') ){
                id = 0;
                this.setState({
                    price_id:0,
                })
                $("#price_"+id).prop('checked', false);
                $(".price_list").prop('checked', false);

                $('#p_results .price').css('display','none');
            }else{
                this.setState({
                    price_id:id,
                })
                $(".price_list").prop('checked', false);
                $("#price_"+id).prop('checked', true);

                $('#p_results .price').html(
                    '&nbsp;> '+$('#price_mobile_'+id).attr('name')
                );
                $('#p_results .price').css('display','block');
            }
            //$('.list_check').css('display','none');
        }
        var option = this.state.option;
        if(option == ''){
            option = 1
        }
        var brand_id = this.state.brand_id;
        if(brand_id == ''){
            brand_id = 0
        }
        var category_id = this.state.category_id;
        if(category_id == ''){
            category_id = 0
        }
        var year_id = this.state.year_id;
        if(year_id == ''){
            year_id = 0
        }
        var vehicle_id = this.state.vehicle_id;
        if(vehicle_id == ''){
            vehicle_id = 0
        }
        var line_id = this.state.line_id;
        if(line_id == ''){
            line_id = 0
        }
        try{
            fetch(https+'api/filter/'+brand_id+'/'+category_id+'/'+option+'/'+year_id+'/'+vehicle_id+'/'+id+'/'+line_id)
                .then(response => response.json())
                .then(data =>{
                    this.setState({
                        products:data[0],
                        brands_list:data[1],
                        categories_list:data[2],
                        lines:data[3],
                        years_list:data[4],
                        vehicles_list:data[5]
                    })
                    $('.pages').hide();
                    $('.page_1').show();

                    $('.not_products').css('display','block');
                    $('.loading').css('display','none');
                    $('html, body').animate({
                        scrollTop: $('.listProducts').offset().top - 100
                    }, 100);
                })
        }catch (error) {
            this.setState({
                error
            })
        }
    }

    changeLine(id){
        this.setState({
            products:[],
        })
        if($(document).width() < 600 ){
            if($('#line_mobile_'+id).is('.dnone')){
                this.setState({
                    line_id:id,
                })
                $(".line_list_mobile").addClass('dnone');
                $("#line_mobile_"+id).removeClass('dnone');
                $('#results .lines p .name').html(
                    $('#line_mobile_'+id).attr('name')
                );
                $('#results .lines').css('display','block');
            }else{
                this.setState({
                    line_id:0,
                })
                id = 0;
                $(".line_list_mobile").addClass('dnone');
                $('#results .lines').css('display','none');
            }
            document.getElementById('allCategories').classList.remove('show');
            document.getElementById('subLine').classList.remove('show');
            document.body.classList.remove('lock-screen');
        }else{
            if( !$("#line_"+id).is(':checked') ){
                id = 0;
                this.setState({
                    line_id:0,
                })
                $("#line_"+id).prop('checked', false);
                $(".line_list").prop('checked', false);

                $('#p_results .lines').css('display','none');
            }else{
                this.setState({
                    line_id:id,
                })
                $(".line_list").prop('checked', false);
                $("#line_"+id).prop('checked', true);

                $('#p_results .lines').html(
                    '&nbsp;> '+$('#line_'+id).attr('name_go')
                );
                $('#p_results .lines').css('display','block');
            }
            //$('.list_check').css('display','none');
        }
        var option = this.state.option;
        if(option == ''){
            option = 1
        }
        var brand_id = this.state.brand_id;
        if(brand_id == ''){
            brand_id = 0
        }
        var category_id = this.state.category_id;
        if(category_id == ''){
            category_id = 0
        }
        var year_id = this.state.year_id;
        if(year_id == ''){
            year_id = 0
        }
        var vehicle_id = this.state.vehicle_id;
        if(vehicle_id == ''){
            vehicle_id = 0
        }
        var price_id = this.state.price_id;
        if(price_id == ''){
            price_id = 0
        }
        try{
            fetch(https+'api/filter/'+brand_id+'/'+category_id+'/'+option+'/'+year_id+'/'+vehicle_id+'/'+price_id+'/'+id)
                .then(response => response.json())
                .then(data =>{
                    this.setState({
                        products:data[0],
                        brands_list:data[1],
                        categories_list:data[2],
                        lines:data[3],
                        years_list:data[4],
                        vehicles_list:data[5]
                    })
                    $('.pages').hide();
                    $('.page_1').show();

                    $('.not_products').css('display','block');
                    $('.loading').css('display','none');
                    $('html, body').animate({
                        scrollTop: $('.listProducts').offset().top - 100
                    }, 100);
                })
        }catch (error) {
            this.setState({
                error
            })
        }
    }

    brandOpen(){
        if($('.brand_list_check').css('display') == 'none'){
            //$('.list_check').css('display','none');
            $('.brand_list_check').css('display','block');
        }else{
            //$('.list_check').css('display','none');
            $('.brand_list_check').css('display','none');
        }
    }

    categoriesOpen(){
        if($('.category_list_check').css('display') == 'none'){
            //$('.list_check').css('display','none');
            $('.category_list_check').css('display','block');
        }else{
            //$('.list_check').css('display','none');
            $('.category_list_check').css('display','none');
        }
    }

    yearsOpen(){
        if($('.year_list_check').css('display') == 'none'){
            //$('.list_check').css('display','none');
            $('.year_list_check').css('display','block');
        }else{
            //$('.list_check').css('display','none');
            $('.year_list_check').css('display','none');
        }
    }

    vehiclesOpen(){
        if($('.vehicle_list_check').css('display') == 'none'){
            //$('.list_check').css('display','none');
            $('.vehicle_list_check').css('display','block');
        }else{
            //$('.list_check').css('display','none');
            $('.vehicle_list_check').css('display','none');
        }
    }    

    priceOpen(){
        if($('.price_list_check').css('display') == 'none'){
            //$('.list_check').css('display','none');
            $('.price_list_check').css('display','block');
        }else{
            //$('.list_check').css('display','none');
            $('.price_list_check').css('display','none');
        }
    } 

    lineOpen(){
        if($('.line_list_check').css('display') == 'none'){
            //$('.list_check').css('display','none');
            $('.line_list_check').css('display','block');
        }else{
            //$('.list_check').css('display','none');
            $('.line_list_check').css('display','none');
        }
    }

    clearFilter(){
        
        $('#option_desktop').val(1);
        $(".category_list").prop('checked', false);
        $(".brand_list").prop('checked', false);
        $(".line_list").prop('checked', false);
        $(".year_list").prop('checked', false);
        $(".vehicle_list").prop('checked', false);
        $(".price_list").prop('checked', false);

        var brand_id = 0;
        var category_id = 0;
        var option = 1;
        var year_id = 0;
        var vehicle_id = 0;
        var price_id = 0;
        var line_id = 0;

        $('#p_results .brands').css('display','none');
        $('#p_results .categories').css('display','none');
        $('#p_results .lines').css('display','none');
        $('#p_results .years').css('display','none');
        $('#p_results .vehicles').css('display','none');
        $('#p_results .price').css('display','none');

        this.setState({
            brand_id:0,
        })
        this.setState({
            category_id:0,
        })
        this.setState({
            option:0,
        })
        this.setState({
            year_id:0,
        })
        this.setState({
            vehicle_id:0,
        })
        this.setState({
            price_id:0,
        })
        this.setState({
            line_id:0,
        })

        //mobile
        $('.category_list_mobile').removeClass('dnone');
        $('.category_list_mobile').addClass('dnone');
        $('.brand_list_mobile').removeClass('dnone');
        $('.brand_list_mobile').addClass('dnone');
        $('.line_list_mobile').removeClass('dnone');
        $('.line_list_mobile').addClass('dnone');
        $('.year_list_mobile').removeClass('dnone');
        $('.year_list_mobile').addClass('dnone');
        $('.vehicle_list_mobile').removeClass('dnone');
        $('.vehicle_list_mobile').addClass('dnone');
        $('.price_list_mobile').removeClass('dnone');
        $('.price_list_mobile').addClass('dnone');

        $('#results .brands').css('display','none');
        $('#results .categories').css('display','none');
        $('#results .lines').css('display','none');
        $('#results .years').css('display','none');
        $('#results .vehicles').css('display','none');
        $('#results .price').css('display','none');

        document.getElementById('allCategories').classList.remove('show');
        document.body.classList.remove('lock-screen');

        try{
            fetch(https+'api/filter/'+brand_id+'/'+category_id+'/'+option+'/'+year_id+'/'+vehicle_id+'/'+price_id+'/'+line_id)
                .then(response => response.json())
                .then(data =>{
                    this.setState({
                        products:data[0],
                        brands_list:data[1],
                        categories_list:data[2],
                        lines:data[3],
                        years_list:data[4],
                        vehicles_list:data[5]
                    })
                    $('.pages').hide();
                    $('.page_1').show();
                })
        }catch (error) {
            this.setState({
                error
            })
        }
    }

    clearMobile(option){
        //console.log(option);
        var category_id = this.state.category_id;
        var brand_id = this.state.brand_id;
        var line_id = this.state.line_id;
        var year_id = this.state.year_id;
        var vehicle_id = this.state.vehicle_id;
        var price_id = this.state.price_id;
        var option_go = this.state.option;

        if(option == 'categories'){
            $('.category_list_mobile').removeClass('dnone');
            $('.category_list_mobile').addClass('dnone');
            $('#results .categories').css('display','none');
            this.setState({
                category_id:0,
            })
            category_id = 0;
        }
        if(option == 'brands'){
            $('.brand_list_mobile').removeClass('dnone');
            $('.brand_list_mobile').addClass('dnone');
            $('#results .brands').css('display','none');
            this.setState({
                brand_id:0,
            })
            brand_id = 0;
        }
        if(option == 'lines'){
            $('.line_list_mobile').removeClass('dnone');
            $('.line_list_mobile').addClass('dnone');
            $('#results .lines').css('display','none');
            this.setState({
                line_id:0,
            })
            line_id = 0;
        }
        if(option == 'years'){
            $('.year_list_mobile').removeClass('dnone');
            $('.year_list_mobile').addClass('dnone');
            $('#results .years').css('display','none');
            this.setState({
                year_id:0,
            })
            year_id = 0;
        }
        if(option == 'vehicles'){
            $('.vehicle_list_mobile').removeClass('dnone');
            $('.vehicle_list_mobile').addClass('dnone');
            $('#results .vehicles').css('display','none');
            this.setState({
                vehicle_id:0,
            })
            vehicle_id = 0;
        }
        if(option == 'prices'){
            $('.price_list_mobile').removeClass('dnone');
            $('.price_list_mobile').addClass('dnone');
            $('#results .price').css('display','none');
            this.setState({
                price_id:0,
            })
            price_id = 0;
        }

        try{
            fetch(https+'api/filter/'+brand_id+'/'+category_id+'/'+option_go+'/'+year_id+'/'+vehicle_id+'/'+price_id+'/'+line_id)
                .then(response => response.json())
                .then(data =>{
                    this.setState({
                        products:data[0],
                        brands_list:data[1],
                        categories_list:data[2],
                        lines:data[3],
                        years_list:data[4],
                        vehicles_list:data[5]
                    })
                    $('.pages').hide();
                    $('.page_1').show();
                })
        }catch (error) {
            this.setState({
                error
            })
        }
    }

    async componentDidMount(){
        //text
        try{
            let res = await fetch(https+'api/text')
            let data = await res.json()
            this.setState({
                text:data[3],
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //brands_list
        try{
            let res = await fetch(https+'api/brands')
            let data = await res.json()
            this.setState({
                brands_list:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //categories_list
        try{
            let res = await fetch(https+'api/categories')
            let data = await res.json()
            this.setState({
                categories_list:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //years_list
        try{
            let res = await fetch(https+'api/years')
            let data = await res.json()
            this.setState({
                years_list:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //vehicles_list
        try{
            let res = await fetch(https+'api/vehicles')
            let data = await res.json()
            this.setState({
                vehicles_list:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //products
        try{
            fetch(https+'api/productsGet')
                .then(response => response.json())
                .then(data =>{
                    this.setState({
                        products:data
                    })
                    $('.not_products').css('display','block');
                    $('.loading').css('display','none');
                })
        }catch (error) {
            this.setState({
                error
            })
        }
        //lines_Totally
        try{
            let res = await fetch(https+'api/lines')
            let data = await res.json()
            this.setState({
                linesT:data,
                lines:data
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //brands_Totally
        try{
            let res = await fetch(https+'api/brands')
            let data = await res.json()
            this.setState({
                brandsT:data
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //category_totally
        try{
            let res = await fetch(https+'api/categories')
            let data = await res.json()
            this.setState({
                categoriesT:data
            })
        }catch (error) {
            this.setState({
                error
            })
        }


        //informacion
        try{
            let res = await fetch(https+'api/info')
            let data = await res.json()
            this.setState({
                info:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //brands
        try{
            let res = await fetch(https+'api/brandsHeader')
            let data = await res.json()
            this.setState({
                brands:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //brands 2
        try{
            let res = await fetch(https+'api/brandsHeader2')
            let data = await res.json()
            this.setState({
                brands_2:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //categories
        try{
            let res = await fetch(https+'api/categoriesHeader')
            let data = await res.json()
            this.setState({
                categories:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //city
        try{
            let res = await fetch(https+'api/cities')
            let data = await res.json()
            this.setState({
                cities:data
            })
        }catch (error) {
            this.setState({
                error
            })
        }

    }
    
    render() {
        return (
            <div>
                <Header
                    brands={this.state.brands}
                    brands_2={this.state.brands_2}
                    categories={this.state.categories}
                />
                <List
                    text={this.state.text}
                    brands={this.state.brands_list}
                    categories={this.state.categories_list}
                    years={this.state.years_list}
                    vehicles={this.state.vehicles_list}
                    products={this.state.products}
                    
                    changeBrand={this.changeBrand}
                    changeCategory={this.changeCategory}
                    option={this.state.option}
                    onChangeOption={this.onChangeOption}
                    prev={this.pagePrev}
                    next={this.pageNext}
                    changeYear={this.changeYear}
                    changeVehicle={this.changeVehicle}
                    changePrice={this.changePrice}

                    brand_select={this.state.brand_select}
                    category_select={this.state.category_select}

                    linesT={this.state.linesT}

                    brandOpen={this.brandOpen}
                    categoriesOpen={this.categoriesOpen}
                    yearsOpen={this.yearsOpen}
                    vehiclesOpen={this.vehiclesOpen}
                    priceOpen={this.priceOpen}

                    lineOpen={this.lineOpen}
                    lines={this.state.lines}
                    changeLine={this.changeLine}

                    brandsT={this.state.brandsT}
                    categoriesT={this.state.categoriesT}

                    clearFilter={this.clearFilter}
                    clearMobile={this.clearMobile}
                />
                <Float
                    info={this.state.info}
                />
                <Modals
                    form={this.state.formRegister}
                    onChange={this.handleChangeFormRegister}
                    onSubmit={this.formRegisterSubmit}
                    recaptchaRefRegister={this._recaptchaRefRegister}
                    onChangeCountry={this.onChangeCountry}
                    onChangeState={this.onChangeState}
                    onChangeCity={this.onChangeCity}
                    cities={this.state.cities}
                    forget={this.forget}
                    formlogin={this.state.formLogin}
                    onChangeLogin={this.handleChangeFormLogin}
                    recaptchaRefLogin={this._recaptchaRefLogin}
                    onSubmitLogin={this.formLoginSubmit}
                />
                <Footer
                    info={this.state.info}
                />
            </div>
        );
    }

}

if (document.getElementById('content_shop')) {
    ReactDOM.render(<Shop />, document.getElementById('content_shop'))
}
